import { AfterViewInit, Component, NgZone } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { Plan, User } from "@app/data/user";
import { environment } from "environments/environment";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Catalog } from "@app/data/catalog";
import { CatalogService } from "@services/catalog.service";
import * as _ from "lodash";
import {
  GlobalSettings,
  GlobalSettingsService,
} from "@app/services/global-settings.service";
import { CouponService } from "@app/services/coupon.service";

declare var gapi;

@Component({
  templateUrl: "./upgrade.component.html",
  animations: [],
})
export class UpgradeComponent {
  hasExpired: boolean;
  promotion: GlobalSettings;
  showCoupon: boolean;

  constructor(
    private couponService: CouponService,
    private globalSettingsService: GlobalSettingsService,
    private userService: UserService
  ) {
    this.userService.hasExpired().then((hasExpired) => {
      this.hasExpired = hasExpired;
    });

    this.userService.me().then((user) => {
      const subscriptions = _.find(user.subscriptions, { duration: null });
      if (subscriptions === undefined) {
        this.globalSettingsService.get("promotion").then((settings) => {
          this.promotion = settings;
          if (this.promotion) {
            this.couponService.query().then((coupons) => {
              const coupon = coupons
                ? coupons[this.promotion.parameters.coupon_code]
                : null;
              this.showCoupon = coupon && coupon.valid;
            });
          }
        });
      }
    });
  }
}
